import React from 'react'
import '../css/bestproduct.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping, faE } from "@fortawesome/free-solid-svg-icons";
import {faEye} from "@fortawesome/free-solid-svg-icons"
import {faHeart} from "@fortawesome/free-solid-svg-icons"

function BestProduct(props) {
    console.log(props.src);
  return (
      <>
      
          <div className='bproduct-wrapper'>
              <h3>{ props.name}</h3>
              <div className='price'>
                  
                  {/* <p>$199,- </p><p>$175,-</p> */}
                  
              </div>
              <img src={props.src} />
              
              <div className='shop-icon'><FontAwesomeIcon className='icon' icon={faCartShopping} /></div>
              <div className='like-button'><FontAwesomeIcon className='icon' icon={faHeart} /></div>
              <div className='view-button'><FontAwesomeIcon className='icon' icon={faEye} /></div>
          </div>
      </>
  )
}

export default BestProduct